<template>
  <div :class="$style.bar">
    <div :class="[$style['bar--left'], $style.left]" :style="style">
      <p v-if="ratio > 10" :class="$style.text">
        資産運用
        <span :class="$style['text--number']"> {{ ratio }}% </span>
      </p>
    </div>
    <p v-if="ratio <= 10" :class="[$style.text, textClass]">
      資産運用
      <span :class="$style['text--number']"> {{ ratio }}% </span>
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed, useCssModule } from 'vue'

const props = defineProps<{
  ratio: number
}>()

const style = computed(() => ({
  width: props.ratio + '%',
}))

const textStyle = useCssModule()
const textClass = computed(() => ({
  [textStyle['text--zero']]: props.ratio === 0,
  [textStyle['text--lessThanTen']]: props.ratio <= 10,
}))
</script>

<style lang="scss" module>
.bar {
  width: 100%;
  height: 44px;
  background-color: $color-gray-200;
  display: flex;
  border-radius: $border-radius-v2-base;

  &--left {
    border-radius: $border-radius-v2-base 0 0 $border-radius-v2-base;
  }
}

.left {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $color-surface-accent-primary;
}

.text {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  white-space: nowrap;
  line-height: 12px;
  font-size: 10px;
  color: $color-text-and-object-high-emphasis-inverse;

  &--number {
    font-size: 16px;
    font-weight: bold;
    line-height: 18px;
  }

  &--lessThanTen {
    color: $color-blue-700;
    margin-left: 8px;
  }

  &--zero {
    color: $color-gray-400;
    width: 100%;
  }
}
</style>
